import { render } from "./AreaChoice.vue?vue&type=template&id=cd0223c6&scoped=true"
import script from "./AreaChoice.vue?vue&type=script&lang=js"
export * from "./AreaChoice.vue?vue&type=script&lang=js"

import "./AreaChoice.vue?vue&type=style&index=0&id=cd0223c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0223c6"]])

export default __exports__